<!-- 
    描述：专家申请记录详情页
-->
<template>
    <div class="filed-info-layout">
        <div class="common-top" ref="formRef">
            <div class="tip-num ">
                <p style="margin-top:8px">
                    通知标题:{{ noticeTitle }}
                </p>
                <!-- <el-button
                    type="primary"
                    class="btn-blue"
                    @click="goBack"
                    size="small"
                    >返回</el-button
                > -->
            </div>
        </div>

        <div class="table">
            <el-table ref="xTable" :data="filterData" height="100%" border>
                <el-table-column
                    type="index"
                    label="序号"
                    align="center"
                    width="100"
                ></el-table-column>
                <el-table-column
                    prop="createUserid"
                    label="已浏览用户id"
                    align="center"
                    show-overflow-tooltip
                    width="200"
                ></el-table-column>
                <el-table-column
                    prop="userName"
                    label="账号"
                    align="center"
                    width="180"
                ></el-table-column>
                <el-table-column
                    prop="createDate"
                    label="浏览时间"
                    show-overflow-tooltip
                    align="center"
                    width="300"
                ></el-table-column>
                <el-table-column
                    prop="sysNo"
                    label="访问业务端"
                    align="center"
                    show-overflow-tooltip
                    min-width="200"
                ></el-table-column>
                <!-- <el-table-column prop="applyState"
								 label="状态"
								 align="center"
								 width="100"
								 show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.applyState == 1">待确认</span>
						<span style="color:green"
							  v-else-if="scope.row.applyState == 2">预约成功</span>
						<span style="color:red"
							  v-else-if="scope.row.applyState == 3">预约失败</span>
					</template></el-table-column> -->
            </el-table>
        </div>
        <div
            class="table-footer w-table-footer"
            style="text-align:center;margin-top:5px;"
        >
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="pageList"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
import tab from '@/components/common/tab'
import { getRecordsDetail } from 'api/modules/notification'
import { mapState } from 'vuex'
export default {
    components: {
        tab
    },
    props: {
        noticeId: {
            type: String,
            default: ''
        },
        sId: {
            type: String,
            default: ''
        },
        noticeTitle: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            dataArray: [
                { label: '全部', name: '0' },
                { label: '预约中', name: '1' },
                { label: '已到场', name: '2' }
            ],
            filterData: [],
            bookState: '0',
            loading: false,
            //筛选框
            currentPage: 1, // 当前页码
            pageList: [10, 20, 50, 100], // 显示条数数组
            pageSize: 20, // 当前显示条数
            total: 0, // 当前总条数
            searchToggle: true
        }
    },
    created() {
        this.getData()
    },
    methods: {
        // 返回
        goBack() {
            this.$router.push({ path: '/notification' })
        },
        getData() {
            let arr = {
                noticeId: this.$route.query.id,
                current: this.currentPage,
                size: this.pageSize
            }
            getRecordsDetail(arr).then(res => {
                if (res.data.records) {
                    this.filterData = res.data.records
                    this.loading = false
                    this.currentPage = parseInt(res.data.current)
                    this.total = parseInt(res.data.total)
                    this.pageSize = parseInt(res.data.size)
                    // 设置回显
                }
            })
        },
        // tab切换
        tabChange(val) {
            this.bookState = val
            this.getData()
        },
        // 切换显示条数
        handleSizeChange(val) {
            this.pageSize = val
            this.getData()
        },

        //切换当前页码
        handleCurrentChange(val) {
            this.currentPage = val
            this.getData()
        }
    },
    computed: {
        ...mapState('dict', { hyslx: state => state.hyslx }),
        ...mapState('dict', { cdrnrs: state => state.cdrnrs }),
        ...mapState('dict', { hyspzxx: state => state.hyspzxx })
    }
}
</script>
<style lang="less" scoped>
.filed-info-layout {
    height: 100%;
    .common-top {
        padding: 10px 0 0 0;
        text-align: left;
        .top-box {
            height: 161px;
            padding: 0 10px 24px 0;
            display: flex;
        }
        .left-area {
            display: flex;
            align-items: center;
            width: 300px;
        }
        .left-box {
            width: 300px;
            height: 93px;
            background: rgb(245, 247, 253);
            border: 1px solid #abc0fa;
            border-radius: 5px;
            display: flex;
            align-items: center;
        }
        .booking,
        .used {
            width: 100px;
            height: 100%;
            padding: 10px 0;
        }
        .splitLine {
            width: 1px;
            height: 60px;
            background-color: #abc0fa;
        }
        .text-style {
            font-size: 12px;
        }
        .number-style {
            font-size: 30px;
        }
        .activeColor {
            color: #2672cc;
        }
        .right-area {
            width: 1000px;
            margin-top: 15px;
            line-height: 33px;
            margin-left: 30px;
            .el-col-5 {
                font-size: 14px;
                color: #666;
                text-align: left;
            }
            .el-col-3 {
                text-align: right;
            }
        }
    }
    .table {
        height: 725px;
        text-align: center;
        padding: 10px 0 0;
    }
    .tip-num {
        padding: 0px 0;
        p {
            padding-left: 10px;
            border-left: 4px solid #2672cc;
            font-size: 16px;
        }
        span {
            color: #2672cc;
            font-size: 18px;
        }
    }
}
</style>
<style lang="less">
.table {
    overflow: auto;
    .el-table__empty-block {
        min-height: 433px;
        text-align: center;
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    .el-table--scrollable-x .el-table__body-wrapper {
        overflow-x: auto;
        height: 440px;
    }
}
</style>
